import ReconnectingWebSocket from "reconnecting-websocket";

// I browser accettano solo 1000 o 3000-4999: 4001 xe nostro, no ghe dà fastidio.
const NORMAL_CLOSE_CODE = 1000;
const VISIBILITY_CLOSE_CODE = 4001;
const VISIBILITY_CLOSE_REASON = "tab hidden or component closed";

const isBrowserCloseCodeAllowed = (code) => {
    // Undefined vol dir: lassa el browser scegliere la chiusura normale.
    return code === undefined || code === NORMAL_CLOSE_CODE || (code >= 3000 && code <= 4999);
};

const normalizeCloseCode = (code) => {
    if (isBrowserCloseCodeAllowed(code)) return code;
    return NORMAL_CLOSE_CODE;
};

const isBrowserTabVisible = () => {
    // Se no semo in browser, no blocchemo gnente.
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
};

const addPageParam = (url) => {
    if (typeof window === "undefined") return url;

    try {
        const socketUrl = new URL(url);
        // Tracciamo la pagina che ga verto el socket: utilissimo par beccare tab matte.
        socketUrl.searchParams.set("page", `${window.location.pathname}${window.location.search}`);
        return socketUrl.toString();
    } catch (e) {
        return url;
    }
};

class VisibilityAwareWebSocket {
    constructor(url, protocols, options) {
        this.url = addPageParam(url);
        this.protocols = protocols;
        this.options = options;
        this.socket = null;
        this.manuallyClosed = false;
        this.onopen = null;
        this.onmessage = null;
        this.onerror = null;
        this.onclose = null;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

        if (typeof document !== "undefined") {
            // Quando la tab sparisse, femo pulizia; quando torna visibile, se tacemo de novo.
            document.addEventListener("visibilitychange", this.handleVisibilityChange);
        }

        if (isBrowserTabVisible()) {
            this.connect();
        }
    }

    connect() {
        if (this.manuallyClosed || this.socket || !isBrowserTabVisible()) return;

        this.socket = new ReconnectingWebSocket(this.url, this.protocols, this.options);
        this.socket.onopen = (event) => {
            if (this.onopen) this.onopen(event);
        };
        this.socket.onmessage = (event) => {
            if (this.onmessage) this.onmessage(event);
        };
        this.socket.onerror = (event) => {
            if (this.onerror) this.onerror(event);
        };
        this.socket.onclose = (event) => {
            // El ReconnectingWebSocket gestisse da solo i retry; no butemo via el riferimento.
            if (this.onclose) this.onclose(event);
        };
    }

    closeSocket() {
        if (!this.socket) return;

        const socket = this.socket;
        this.socket = null;
        // Xe una chiusura voluta: tab nascosta o componente distrutto.
        socket.close(VISIBILITY_CLOSE_CODE, VISIBILITY_CLOSE_REASON);
    }

    handleVisibilityChange() {
        if (this.manuallyClosed) return;

        if (isBrowserTabVisible()) {
            this.connect();
        } else {
            this.closeSocket();
        }
    }

    send(data) {
        if (!this.socket || this.socket.readyState !== WebSocket.OPEN) return false;
        this.socket.send(data);
        return true;
    }

    close(code, reason) {
        this.manuallyClosed = true;

        if (typeof document !== "undefined") {
            document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        }

        if (this.socket) {
            const socket = this.socket;
            this.socket = null;
            socket.close(normalizeCloseCode(code), reason);
        }
    }

    get readyState() {
        if (!this.socket) return WebSocket.CLOSED;
        return this.socket.readyState;
    }
}

export default VisibilityAwareWebSocket;
